import AnimatedBlock from "../../atoms/AnimatedBlock/AnimatedBlock";

const RecordLoader = () => {
  return (
    <>
      <AnimatedBlock className="my-1.5 h-5 w-1/3" />
      <AnimatedBlock className="my-3 h-5 w-1/3" />
      <AnimatedBlock className="mt-3 my-1.5 h-5" />
      <AnimatedBlock className="mt-3 my-1.5 h-5" />
      <AnimatedBlock className="mt-3 h-5 w-1/3" />
      <AnimatedBlock className="mt-3 my-1.5 h-5" />

      <div className="mt-2 grid grid-cols-12 gap-3">
        <AnimatedBlock className="col-span-12 md:col-span-6 w-full h-40" />
        <AnimatedBlock className="col-span-12 md:col-span-6 w-full h-40" />
        <AnimatedBlock className="col-span-12 md:col-span-6 w-full h-40" />
      </div>
      <AnimatedBlock className="mt-3 my-1.5 h-5 w-1/3" />
      <AnimatedBlock className="my-1.5 h-10" />
      <AnimatedBlock className="my-1.5 h-10" />
    </>
  );
};

export default RecordLoader;
